import { render, staticRenderFns } from "./VProduct.vue?vue&type=template&id=458292e3&"
import script from "./VProduct.vue?vue&type=script&lang=js&"
export * from "./VProduct.vue?vue&type=script&lang=js&"
import style0 from "./VProduct.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports